/**
 * Constants for lesson progress tracking
 */

/**
 * Interval (in milliseconds) for auto-saving video progress while playing
 * Default: 5000ms (5 seconds)
 */
export const VIDEO_PROGRESS_SAVE_INTERVAL_MS = 5000;

/**
 * Video completion threshold (percentage watched to mark video as complete).
 * 100 = only when the video has finished (or player reports 100%); use a lower value (e.g. 90) to allow completion before the end.
 */
export const VIDEO_COMPLETION_THRESHOLD_PERCENT = 100;
